// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { LanguageProvider } from './i18n/LanguageContext';

// Créez une racine et utilisez-la pour rendre votre application
const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <LanguageProvider>
            <App />
        </LanguageProvider>
    </React.StrictMode>
);
